import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center min-h-[60vh] px-4 text-center'>
      <p className='text-6xl font-extrabold text-primary mb-4'>404</p>
      <h1 className='text-2xl font-bold text-brand-gray mb-2'>{t('notFound.title')}</h1>
      <p className='text-gray-500 mb-8'>{t('notFound.description')}</p>
      <Link
        to='/'
        className='px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-primary-dark transition'>
        {t('notFound.home')}
      </Link>
    </div>
  );
}
